import { render, staticRenderFns } from "./EditReport.vue?vue&type=template&id=676bc5de&scoped=true"
import script from "./EditReport.vue?vue&type=script&lang=js"
export * from "./EditReport.vue?vue&type=script&lang=js"
import style0 from "./EditReport.vue?vue&type=style&index=0&id=676bc5de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676bc5de",
  null
  
)

export default component.exports